// extracted by mini-css-extract-plugin
export default {"container":"OtTiLBN4O2es29w9Qbz0","conversationsContainer":"DiU8whA8bMjWaNSi8UWg","conversation":"Z3YL5ySuM_8a8Td3p1qg"};